import { HttpContext } from 'cookies-next'

export const COOKIE_USER_ID: string = 'userId'
export const COOKIE_I18N_USER_COUNTRY: string = 'i18nUserCountry'
export const COOKIE_ONETRUST_CONSENT: string = 'OptanonConsent'

// @see https://github.com/andreizanik/cookies-next
export const defaultCookieConfig: Omit<HttpContext, 'name' | 'value'> = {
  sameSite: 'strict',
  secure: process.env.NODE_ENV === 'production',
  // Include a dot before the domain to allow the cookie to
  // be accessible across the domain and all its subdomains.
  domain: process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_VERCEL_ENV !== 'preview' ? `.${process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}` : undefined,
}
